<template>
<div class="modal fade" :id="`modal-${element.id}-${ rowIndex !== undefined ? rowIndex : '' }`" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ element.title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="search-addon"><i class="fas fa-search"></i></span>
                </div>
                <input type="text" class="form-control" v-model="searchKey" placeholder="Search your data here" aria-label="Username" aria-describedby="search-addon">
            </div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead class="thead-dark">
                        <tr v-if="element.dtElements">
                            <th v-for="head in element.dtElements" :key="head.id">{{ head.title }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, rowIndex) in filteredCollection" :key="rowIndex" data-dismiss="modal" @click.prevent="selectRow(data)">
                            <td v-for="(element, colIndex) in element.dtElements" :key="colIndex" >
                                <!-- <input v-if="element.isInput" :type="element.type" v-model="data[element.column]"> -->
                                <div>{{ (element.type === 'number') ? numeral(data[element.column]).format('0,0') : data[element.column] }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
    </div>
</div>
</template>

<script>
import api from '../services/api'

export default {
    props: ['element', 'rowIndex'],
    data() {
        return {
            searchKey: '',
            collections: []
        }
    },
    computed: {
        filteredCollection() {
            return this.collections.filter(x =>
                this.element.filter.some(el => x[el].toLowerCase().includes(this.searchKey.toLowerCase()))
            )
        }
    },
    methods: {
        selectRow(data) {
            this.$emit('selectedRow', data)
        },
        async fetchCollectionData(apiUrl) {
            const lookupApi = api(apiUrl)
            const result = await lookupApi.get()
            this.collections.splice(0, this.collections.length, ...result)
        },
        async fetchCollectionDataByParams({ apiUrl, query }) {
            const lookupApi = api(apiUrl)
            const result = await lookupApi.getWithQuery(query)
            this.collections.splice(0, this.collections.length, ...result)
        }
    }
}
</script>